module.exports = __webpack_public_path__ + "assets/devices/Clip-PG2-47090d7393396a65a8b624f6847ddc46.svg";